import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { productBrandService } from "../../../services/settings-services";

const initialState = {
  productBrands: [],
  status: null,
  error: null,
  trigger: 0,
};

const getAllProductBrands = createAsyncThunk(
  "productBrandsSlice/getAllProductBrands",
  async (_, { rejectWithValue }) => {
    try {
      const response = await productBrandService.getAll();

      return response;
    } catch (e) {
      return rejectWithValue(
        e.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const productBrandsSlice = createSlice({
  name: "productBrandsSlice",
  initialState,
  reducers: {
    changeTrigger: (state, action) => {
      state.trigger = state.trigger + 1;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getAllProductBrands.pending, (state) => {
        state.status = "Loading";
        state.error = null;
      })
      .addCase(getAllProductBrands.fulfilled, (state, action) => {
        state.status = "fulfilled";
        // Ensure we always set an array, handle different response structures
        state.productBrands = action.payload;
      })
      .addCase(getAllProductBrands.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      }),
});

const { reducer: productBrandsReducer, actions } = productBrandsSlice;
const productBrandsActions = {
  ...actions,
  getAllProductBrands,
};

export { productBrandsReducer, productBrandsActions };
